// Add global to window, assigning the value of window itself.
(window as any).global = window;
